import {
  buildLocalBusinessSchema,
  buildOrganizationSchema,
  buildWebSiteSchema,
} from '@/utils/json-ld'
import { JsonLd } from './json-ld'

/**
 * Site-wide JSON-LD schemas: Organization, LocalBusiness (ClothingStore), WebSite.
 * Rendered once in root layout. Individual pages add Product / BreadcrumbList / Article schemas themselves.
 */
export const GlobalJsonLdSchema = () => (
  <>
    <JsonLd id="organization-schema" schema={buildOrganizationSchema()} />
    <JsonLd id="local-business-schema" schema={buildLocalBusinessSchema()} />
    <JsonLd id="website-schema" schema={buildWebSiteSchema()} />
  </>
)
